import { render, staticRenderFns } from "./ModalCadastroOcorrencias.vue?vue&type=template&id=3fb879c7&scoped=true"
import script from "./ModalCadastroOcorrencias.vue?vue&type=script&lang=js"
export * from "./ModalCadastroOcorrencias.vue?vue&type=script&lang=js"
import style0 from "./ModalCadastroOcorrencias.vue?vue&type=style&index=0&id=3fb879c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb879c7",
  null
  
)

export default component.exports